import axios from 'axios';
import store from '../redux/store/store';
const API_BULK_URL = import.meta.env.VITE_API_URL;

const BulkTextTransactionService = {
  addBulkText: async (request, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_BULK_URL}/BulkTextTransaction`,
        request,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response?.data;
    } catch (error) {
      console.error("bulk text eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },

  fetchBulkText: async (userId, token, page, pageSize) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/BulkTextTransaction', {
        params: {
          withCategory: true,
          withMarketpleaces: true,
          userId: userId,
          page: page,
          pageSize: pageSize
        },
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      });
      console.log('BulkTextTransactionService Response:', response?.data); // Debug
      return response?.data;
    } catch (error) {
      console.error('Error fetching bulk text:', error);
      throw error;
    }
  },
}

export default BulkTextTransactionService;

